var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-chat-message-image"},[_c('div',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"img-container flex"},[_c('img',{attrs:{"src":_vm.item.image},on:{"click":_vm.openLightbox}})])])}
var staticRenderFns = []

export { render, staticRenderFns }